import React, { ReactNode } from "react";
import teamscxLogo from "../assets/images/teamscx.png";

interface NotificationPageProps {
  content?: ReactNode;
  enableRotation?: boolean;
}

const NotificationPage: React.FC<NotificationPageProps> = ({ 
  content = "",
  enableRotation = true 
}) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "#e3eaf2"
  }}>
    <style>
      {`
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .rotating-icon {
          animation: ${enableRotation ? 'rotate 3s linear infinite' : 'none'};
        }
      `}
    </style>
    <img
      src={teamscxLogo}
      alt="TeamsCX Logo"
      className="rotating-icon"
      style={{ 
        width: 60, 
        height: 60, 
        marginBottom: 24,
        borderRadius: "8px"
      }}
    />
    {content}
  </div>
);

export default NotificationPage; 